module.exports = __webpack_public_path__ + "static/compact2-c27e405ba2cd1f2573c24520977306d2.png";